import { useRealtime } from './RealtimeProvider';

/** Estado da conexão de tempo real. */
export const useRealtimeStatus = () => {
  const { status, isConnected, lastError } = useRealtime();

  return { status, isConnected, lastError };
};

export default useRealtimeStatus;
